import { useEffect, useState } from "react";
import Spinner from "../Loader/Spinner";
import axios from "axios";
import { BaseURL, DeleteData, getData } from "../../FatchApi/FatchApi";

export default function HeroBanner() {
  const [heroBanners, setHeroBanners] = useState({
    hero1: "",
    hero2: "",
    hero3: "",
    hero4: "",
    hero5: "",
  });
  const [banners, setBanners] = useState("");
  const [spinner, setSpinner] = useState(false);

  const getHeroBanners = async () => {
    const res = await getData(`api/images/get-all-images/heroBanner`);
    setBanners(res.banners?.heroBanner);
  };
  useEffect(() => {
    getHeroBanners();
  }, []);
  // const handleImageChange = (event, index) => {
  //   const selectedFiles = Array.from(event.target.files);

  //   for (let i = 0; i < selectedFiles.length; i++) {
  //     let file = selectedFiles[i];
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onloadend = () => {
  //       setNewImages((prevImages) => {
  //         const updatedImages = [...prevImages]; // Create a copy of the previous images
  //         updatedImages[index] = reader.result; // Set the new image at the given index
  //         return updatedImages; // Return the updated array
  //       });
  //     };
  //   }
  // };
  // const uploadHeroBanner = async () => {
  //   console.log(newImages);
  //   const res = await axios.post(`${BaseURL}/api/images/hero-banner-upload`, {
  //     heroBanner: newImages,
  //   });
  // };
  const heroBannerKeys = [];
  for (const key in heroBanners) {
    heroBannerKeys.push(key);
  }
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setHeroBanners((prev) => ({
        ...prev,
        [name]: reader.result,
      }));
    };
  };
  const uploadBanner = async (item) => {
    setSpinner(true);
    const res = await axios.post(`${BaseURL}/api/images/hero-banner-upload`, {
      [item]: heroBanners[item],
    });
    if (res.data.success) {
      setHeroBanners((prev) => ({
        ...prev,
        [item]: "",
      }));
      setSpinner(false);
      getHeroBanners();
    } else {
      alert("something went wrong");
    }
  };
  const deleteSingleHeroBanner = async (item) => {
    setSpinner(true);
    const res = await DeleteData(
      `api/images/delete-hero-single-banner/${item}`
    );
    if (res.success) {
      getHeroBanners();
      setSpinner(false);
    } else {
      alert("something went wrong");
    }
  };
  return (
    <>
      {spinner ? <Spinner /> : ""}
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-center text-white">
          Hero Banner
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {heroBannerKeys.map((item, i) => {
            return (
              <div>
                <div className="relative group">
                  <img
                    src={
                      (heroBanners && heroBanners[item]) ||
                      (banners && banners[item]?.url) ||
                      "../camera-placeholder.png"
                    }
                    alt={`Gallery image`}
                    className="w-full h-auto object-cover rounded-lg shadow-md transition-transform duration-300 group-hover:scale-105"
                  />

                  <div className="inset-0 hidden group-hover:absolute group-hover:flex bg-black bg-opacity-50 items-center justify-center rounded-lg transition-opacity duration-300">
                    <label
                      for={`file${i}`}
                      role="button"
                      className="bg-white  text-gray-800 font-semibold py-2 px-4 rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300"
                    >
                      Change Image
                    </label>
                    {banners && banners[item]?.url ? (
                      <label
                        // for={`file${i}`}
                        onClick={() => deleteSingleHeroBanner(item)}
                        role="button"
                        className="bg-red-900 mx-2  text-white font-semibold py-2 px-4 rounded-full shadow-lg hover:bg-red-400 transition-colors duration-300"
                      >
                        Delete
                      </label>
                    ) : (
                      ""
                    )}
                  </div>

                  <input
                    type="file"
                    name={item}
                    className="hidden"
                    id={`file${i}`}
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
                {heroBanners[item] !== "" ? (
                  <>
                    {" "}
                    <div className="flex justify-center my-4">
                      <label
                        onClick={() => uploadBanner(item)}
                        for="uploadFile1"
                        class="flex bg-gray-800 hover:bg-gray-700 text-white text-base px-5 py-3 outline-none rounded w-max cursor-pointer mx-auto font-[sans-serif]"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-6 mr-2 fill-white inline"
                          viewBox="0 0 32 32"
                        >
                          <path
                            d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                            data-original="#000000"
                          />
                          <path
                            d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                            data-original="#000000"
                          />
                        </svg>
                        Upload
                      </label>
                    </div>
                  </>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
